<div class="p-0 d-inline-block">
    <div class="img-attach-Upload imgCancel">
        <i class="fn-global-times-o red" (click)="fileAction('DELETE')" [ngClass]="{'disable' :isDeleteDisabled}"></i>
        <div class="fn-ui-file-icon  cursor-pointer">
            <i [class]="cloudFile.fileIcon" ></i>
        </div>
        <div class="row m-0 imgDownload">
            <div class="col-10 text-truncate p-0 imgDownload-text" [title]="cloudFile.fileName">{{cloudFile.fileName}}</div>
            <div class="col-2 p-0 text-right imgDownload-download" (click)="fileAction('DOWNLOAD')"><i class="fn-global-download"></i></div>
        </div>
    </div>
</div>